import {
  LayoutDashboard, BrainCircuit, Target, Lightbulb, Clapperboard,
  Library, FileText, LineChart, Plug, Settings, CreditCard, Wand2,
} from "lucide-react";

// Primary + secondary navigation. `ready` items are built in this foundation;
// others render a Coming Soon placeholder (no fake functionality).
export const PRIMARY_NAV = [
  { label: "Overview", to: "/dashboard", icon: LayoutDashboard, ready: true },
  { label: "Intelligence", to: "/intelligence", icon: BrainCircuit, ready: true },
  { label: "Opportunities", to: "/opportunities", icon: Target, ready: true },
  { label: "Ideas", to: "/ideas", icon: Lightbulb, ready: true },
  { label: "Hook Analyzer", to: "/hook-analysis", icon: Wand2, ready: true },
  { label: "Content", to: "/content", icon: FileText, ready: true },
  { label: "Production", to: "/production", icon: Clapperboard, ready: true },
  { label: "Library", to: "/library", icon: Library, ready: true },
  { label: "Analytics", to: "/analytics", icon: LineChart, ready: true },
];

export const SECONDARY_NAV = [
  { label: "Plans & Billing", to: "/pricing", icon: CreditCard, ready: true },
  { label: "Connections", to: "/connections", icon: Plug, ready: true },
  { label: "Settings", to: "/settings", icon: Settings, ready: true },
];

